const contentStructure = {
    init() {
        let contentStructure = document.querySelector('.c-content-structure');

        if (! contentStructure) {
            return;
        }
        let self = this;

        self._responsiveBehaviour(contentStructure);
    },


    toggleContent(button) {
        let contentStructure = button.parentElement;

        if (contentStructure.classList.contains('c-content-structure--opened')) {
            contentStructure.querySelector('.c-content-structure__content').style.height = '0px';
            contentStructure.classList.remove('c-content-structure--opened')
        }
        else {
            contentStructure.querySelector('.c-content-structure__content').style.height = contentStructure.dataset.contentHeight + 'px';
            contentStructure.classList.add('c-content-structure--opened')
        }
    },

    _responsiveBehaviour(contentStructure) {
        let contentHeight = contentStructure.querySelector('.c-content-structure__content-list').offsetHeight;
        contentStructure.dataset.contentHeight = parseFloat(contentHeight) + 18;
        //contentStructure.querySelector('.c-content-structure__content').style.height = contentHeight + 18 + 'px';
        //contentStructure.classList.add('c-content-structure--opened');
    }
};

window.contentStructure = contentStructure;

window.contentStructure.init();

document.addEventListener('LokiRequestEnd', function () {
    window.contentStructure.init();
});